import React, { useState, useEffect } from "react";
import Card from "../HistorServiciosMto/Card";
import styles from "./CardContainer.module.css";
import { FaInbox } from 'react-icons/fa';

export default function CardContainer({ allticketced, searchTerm, estadoFilter, tecnicoFilter }) {
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 8; // Reduced for better density with Pro cards

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, estadoFilter, tecnicoFilter]);

  if (!Array.isArray(allticketced) || allticketced.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
        <FaInbox size={50} style={{ marginBottom: '15px', opacity: 0.5 }} />
        <p style={{ fontSize: '1.1rem', fontWeight: '600' }}>Cargando registros del historial...</p>
      </div>
    );
  }

  // Preparar los datos para las tarjetas
  const allTickets = allticketced.map(item => {
    const allRegistros = [...(item.registros || [])].sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    const ultimoRegistro = allRegistros[allRegistros.length - 1] || {};

    // Obtener la votación: Buscar cualquier registro que tenga una votación (generalmente el de estado Cerrado)
    const registroConVotacion = [...allRegistros].reverse().find(r => r.votacion !== null);

    // Buscar el técnico: El más reciente que tenga un nombre válido (no el mensaje por defecto)
    const registroConTecnico = [...allRegistros].reverse().find(r =>
      r.nombre_tecnico &&
      r.nombre_tecnico !== 'Sin técnico asignado' &&
      r.nombre_tecnico.trim() !== ""
    );

    return {
      TicketId: item.ticket.id,
      fecha: ultimoRegistro.fecha || item.ticket.fecha,
      fechaCreacion: item.ticket.fecha,
      observacion: ultimoRegistro.resolucion?.observaciones_gen || ultimoRegistro.observacion || item.ticket.Observacion,
      observacionOriginal: item.ticket.Observacion,
      EstadoId: ultimoRegistro.EstadoId || item.ticket.EstadoId,
      nombreTecnico: registroConTecnico?.nombre_tecnico || "Sin asignar",
      votacion: registroConVotacion?.votacion || null,
      nombre: item.nombreUsuario || "Usuario desconocido",
      cargoUsuario: item.cargoUsuario || "Usuario",
      equipo: item.equipo?.Nombrequipo || "N/A",
      cod: item.equipo?.cod || "N/A",
      fullHistorial: allRegistros
    };
  });

  // Filtrar por término de búsqueda y filtros laterales
  const filteredTickets = allTickets.filter(ticket => {
    const searchTrimmed = searchTerm.trim().toLowerCase();
    const matchesSearch =
      ticket.TicketId.toString().includes(searchTrimmed) ||
      ticket.nombre.toLowerCase().includes(searchTrimmed) ||
      ticket.equipo?.toString().toLowerCase().includes(searchTrimmed) ||
      ticket.cod?.toString().toLowerCase().includes(searchTrimmed);

    const matchesEstado = estadoFilter === "ALL" || ticket.EstadoId.toString() === estadoFilter;
    const matchesTecnico = tecnicoFilter === "ALL" || ticket.nombreTecnico === tecnicoFilter;

    return matchesSearch && matchesEstado && matchesTecnico;
  });

  // Ordenar por fecha descendente
  const sortedTickets = filteredTickets.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  // Paginación
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = sortedTickets.slice(indexOfFirstCard, indexOfLastCard);
  const totalPages = Math.ceil(filteredTickets.length / cardsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        {currentCards.length > 0 ? (
          currentCards.map((ticket) => (
            <Card key={ticket.TicketId} ticket={ticket} />
          ))
        ) : (
          <div style={{ textAlign: 'center', gridColumn: '1 / -1', padding: '40px', color: '#94a3b8' }}>
            <p>No se encontraron resultados para los filtros aplicados.</p>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            Anterior
          </button>
          <div style={{ display: 'flex', gap: '5px' }}>
            {Array.from({ length: totalPages }, (_, index) => (
              (index + 1 === 1 || index + 1 === totalPages || (index + 1 >= currentPage - 1 && index + 1 <= currentPage + 1)) && (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={currentPage === index + 1 ? styles.activePage : ""}
                >
                  {index + 1}
                </button>
              )
            ))}
          </div>
          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            Siguiente
          </button>
        </div>
      )}
    </div>
  );
}
